import { usePost, useDelete } from '../../../sharedModules/hooks/useQuery';

const URL = '/collections/department_group_memberships';

export function useAddGroupMembership() {
  return usePost();
}

export function addGroupMembershipVariables(userId: number, groupId: string, location: string) {
  return { url: URL, data: { user_id: userId, group_id: groupId, location } };
}

export function useRemoveGroupMembership() {
  return useDelete();
}

// location rides in the query string because useDelete sends no body.
export function removeGroupMembershipVariables(membershipId: number, location: string) {
  return { url: `${URL}/${membershipId}?location=${encodeURIComponent(location)}` };
}
